import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=bd6490e2&scoped=true"
import script from "./step2.vue?vue&type=script&lang=ts"
export * from "./step2.vue?vue&type=script&lang=ts"
import style0 from "./step2.vue?vue&type=style&index=0&id=bd6490e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6490e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6490e2')) {
      api.createRecord('bd6490e2', component.options)
    } else {
      api.reload('bd6490e2', component.options)
    }
    module.hot.accept("./step2.vue?vue&type=template&id=bd6490e2&scoped=true", function () {
      api.rerender('bd6490e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onBoarding/components/Steps/step2.vue"
export default component.exports